import React, {Component} from 'react';
import Datas from '../../data/shop/mondiya/details.json';
import {Link} from 'react-router-dom';
import {Container, Row, Col, Tab, Table} from 'react-bootstrap';
import HeaderTwo from '../../components/mondiya/HeaderTwo';
import {BreadcrumbBox} from '../../components/common/mondiya/Breadcrumb';
import FooterTwo from '../../components/mondiya/FooterTwo';
import {Styles} from './styles/productDetails.js';
import { withTranslation } from 'react-i18next';

class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: [],
            redirectToProductCategory: false,
        };
    }

    componentDidMount() {
        const product_slug = this.props.match.params.product_slug;
        this.filterProducts(product_slug);

        // Ensure mobile menu is properly initialized on direct page refresh
        this.initializeMobileMenu();

        // Also try after a short delay as backup
        setTimeout(() => {
            this.initializeMobileMenu();
        }, 100);

        // Final attempt after longer delay
        setTimeout(() => {
            this.initializeMobileMenu();
        }, 500);
    }

    componentDidUpdate(prevProps) {
        const prevProductName = prevProps.match.params.product_slug;
        const currentProductName = this.props.match.params.product_slug;

        if (prevProductName !== currentProductName && !this.state.filteredData.length) {
            this.filterProducts(currentProductName);
        }
    }

    filterProducts(product_slug) {
        const filteredData = Datas.filter((product) => product.product_slug === product_slug && product.status === "1");

        if (filteredData.length === 0 && !this.state.redirectToProductCategory) {
            this.setState({redirectToProductCategory: true});

            this.props.history.push(`${process.env.PUBLIC_URL}/product-category`);
            window.location.reload();
        } else {
            this.setState({filteredData});
        }
    }

    initializeMobileMenu = () => {
        // Re-initialize mobile menu to ensure it works on direct page refresh
        const mobileMenuArea = document.querySelector('.mobile-menu-area');
        const hmBtn = document.getElementById("mb-sidebar-btn");

        // Force mobile menu area to be visible on mobile screens
        if (mobileMenuArea && window.innerWidth <= 767) {
            mobileMenuArea.style.display = 'block';
            mobileMenuArea.style.background = '#182B49';
        }

        if (hmBtn) {
            const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
            const mdSidebarBody = document.getElementById("mb-sidebar-body");

            // Force hamburger button to be visible
            hmBtn.style.display = 'inline-block';
            hmBtn.style.padding = '8px 12px';
            hmBtn.style.cursor = 'pointer';

            const hamburgerIcon = hmBtn.querySelector('i');
            if (hamburgerIcon) {
                hamburgerIcon.style.display = 'inline-block';
                hamburgerIcon.style.fontSize = '20px';
                hamburgerIcon.style.color = '#11B67A';
            }

            // Ensure styles are applied to sidebar
            if (mdSidebarBody) {
                mdSidebarBody.style.display = 'block';
                mdSidebarBody.style.background = '#ffffff';
                mdSidebarBody.style.zIndex = '99999';
            }

            if (mdSidebarOverlay) {
                mdSidebarOverlay.style.zIndex = '9998';
            }

            // Force style application for menu items
            const menuLinks = document.querySelectorAll('.mb-sidebar .mb-menu-content a');
            menuLinks.forEach(link => {
                link.style.color = '#182B49';
                link.style.fontSize = '14px';
                link.style.fontWeight = '500';
                link.style.textDecoration = 'none';
                link.style.display = 'block';
                link.style.padding = '10px 0 10px 15px';
            });
        }
    }

    render() {
        const {filteredData, redirectToProductCategory} = this.state;
        const { t } = this.props;

        if (redirectToProductCategory) {
            return null;
        }

        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper product-details-page">

                    {/* Header 2 */}
                    <HeaderTwo/>

                    {/* Breadcrumb */}
                    <BreadcrumbBox title={t('shop.productDetails.breadcrumbs3')}/>

                    {/* Product Details */}
                    <section className="product-details-area">
                        <Container>
                            <Row>
                                <Col lg="12" md="12" className="product-top-navbar">
                                    {filteredData.length > 0 && (
                                        <nav className="navbar navbar-dark bg-dark">
                                            <span className="navbar-brand mb-0 h1">
                                                <Link to={`${process.env.PUBLIC_URL}/`} className="product-link">{t('shop.home')}</Link> > <Link to={`${process.env.PUBLIC_URL}/product-category`} className="product-link">{t('shop.product')}</Link> > <Link to={`${process.env.PUBLIC_URL}/products/${filteredData[0].category}`} className="product-link">{t(`shop.productCategory.categories.${filteredData[0].category}`)}</Link> &gt; <span className="product-text">{filteredData[0].productTitle}</span>
                                            </span>
                                        </nav>
                                    )}
                                </Col>
                            </Row>
                            {filteredData.length > 0 ? (
                                filteredData.map((data, i) => (
                                    <Row key={i}>
                                        <Col md="5">
                                            <div className="product-slider">
                                                <div className="slider-item">
                                                    <img
                                                        src={process.env.PUBLIC_URL + `/assets/images/${data.productImg}`}
                                                        alt={data.productTitle} className="img-fluid"/>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col md="7">
                                            <div className="product-information">
                                                <div className="product-title">
                                                    <h4>{data.productTitle}</h4>
                                                </div>
                                                <div className="product-price d-flex">
                                                    <p className="dc-price">{data.anotherName}</p>
                                                </div>
                                                <div className="product-desc">
                                                    <p>{data.description}</p>
                                                </div>
                                            </div>
                                            <div md="12">
                                                <Col md="12">
                                                    <div className="product-tab">
                                                        <Tab.Container defaultActiveKey="additional">
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="additional"
                                                                          className="additional-tab">
                                                                    <Table className="table table-bordered">
                                                                        <tbody>
                                                                        <tr>
                                                                            <td className="width-40">{t(`shop.productDetails.detailsTable.id`)}</td>
                                                                            <td className="width-60">{data.product_id}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="width-40">{t(`shop.productDetails.detailsTable.details`)}</td>
                                                                            <td className="width-60 details-row">{data.details}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="width-40">{t(`shop.productDetails.detailsTable.addDetails`)}</td>
                                                                            <td className="width-60 details-row">{data.additional_details}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="width-40">{t(`shop.productDetails.detailsTable.available`)}</td>
                                                                            <td className="width-60">{data.available}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="width-40">{t(`shop.productDetails.detailsTable.moq`)}</td>
                                                                            <td className="width-60">{data.moq}</td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </Table>
                                                                    <Link className="readmore-btn" to={`${process.env.PUBLIC_URL}/quote?slug=${data.product_slug}`}>Get Quote</Link>
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </Tab.Container>
                                                    </div>
                                                </Col>
                                            </div>
                                        </Col>
                                    </Row>
                                ))
                            ) : (
                                <p>No details found for this product.</p>
                            )}
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo/>

                </div>
            </Styles>
        );
    }
}

export default withTranslation()(ProductDetails);